export const validateRequiredNode = (value, setProp) => {
    setProp(props => {
        props.error.required.isVisible = !value;
        props.value = value;
    })
};